import { useIsFetching } from 'react-query';

const ANALYTICS_QUERY_NAMESPACE = 'analytics';

/**
 * Every query whose result a viewer is waiting to see. A segment missing from here is
 * fetched invisibly: nothing moves, and then a number appears on its own.
 *
 * `v2-performance` covers both halves of the v2 read path — the selected period and the
 * period it is compared against. The comparison resolves after the tiles have rendered,
 * so without it the trend badges arrive with no warning that anything was still running.
 */
export const ANALYTICS_DATA_QUERY_SEGMENTS = [
  'overview',
  'performance',
  'v2-performance',
  'audience',
  'content',
] as const;

const dataSegments = new Set<string>(ANALYTICS_DATA_QUERY_SEGMENTS);

export function useIsAnalyticsDataFetching(): boolean {
  const fetchingCount = useIsFetching({
    predicate: (query) => {
      const [namespace, segment] = query.queryKey as readonly unknown[];
      return (
        namespace === ANALYTICS_QUERY_NAMESPACE &&
        typeof segment === 'string' &&
        dataSegments.has(segment)
      );
    },
  });

  return fetchingCount > 0;
}
